export const userFacingMessage = (body: unknown): string | undefined => {
  const { message, userFacing } = (body ?? {}) as { message?: unknown; userFacing?: unknown };
  return userFacing === true && typeof message === 'string' && message.trim().length > 0 ? message : undefined;
};
